export function ready(fn: (ev?: Event) => any) {
  if (document.readyState !== 'loading') {
    fn()
    return
  }

  document.addEventListener('DOMContentLoaded', fn)
}
